import Container from "../components/Layout/Container";
import { setSidetittel } from "../utils/common";
import { ReactNode } from "react";
import Heading from "../components/sheriff-wrappers/Heading";

export type FeilSideProps = {
  sidetittel?: string;
  header: string;
  infotekst: string;
  children: ReactNode;
};

export const Feilside = ({
  sidetittel,
  header,
  infotekst,
  children,
}: FeilSideProps) => {
  if (sidetittel) {
    setSidetittel(sidetittel);
  }

  return (
    <Container className={"sds-spacing-p-b-md"}>
      <Heading>{header}</Heading>
      <p className={"sds-spacing-p-b-md"}>{infotekst}</p>
      {children}
    </Container>
  );
};
